import { googleMapsQueryKeys as e } from "./useGoogleMapsQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { googleMapsApi as n } from "@maat/api-base";
//#region src/googleMaps/usePlaceDetailsQuery.ts
var r = (r) => t({
	queryKey: e.details(r),
	queryFn: () => n.getPlaceDetails(r),
	enabled: !!r
});
//#endregion
export { r as usePlaceDetailsQuery };
